/**
 * Recently viewed products component
 */

(function($, undefined) {
    let recently_viewed_products = $('.shop-recently-viewed');
    let recently_viewed_products_wrapper = $('.shop-recently-viewed .swiper-wrapper');

    if (recently_viewed_products_wrapper.length > 0) {
        $.ajax({
            url: themevars.ajaxurl,
            data: {
                action: 'get_recently_viewed_products',
            },
            type: 'POST',
            dataType: 'json',
        }).done(function(response) {
            if (response.data) {
                recently_viewed_products_wrapper.html(response.data);
                $(recently_viewed_products).css('display', 'block');
            }
        });
    }
})(jQuery);

